import { Component, Input, OnInit } from '@angular/core';
import { AnalyticsBean } from '../../../beans/analytics/analytics-module.bean';
import { Router } from '@angular/router';

@Component({
	selector: 'app-coaching-appointment',
	templateUrl: './coaching-appointment.component.html',
	styleUrls: ['./coaching-appointment.component.scss'],
})
export class CoachingAppointmentComponent implements OnInit {
	@Input() eligibleForPE: boolean;
	@Input() eligibleForHM: boolean;
	@Input() hasFutureConfirmedAppt: boolean;
	analyticsData: AnalyticsBean;
	currentApptDate: String;
	expirationDate: String;
	sessionRemaining: number;

	constructor(private router: Router) {
		this.analyticsData = new AnalyticsBean();
		this.analyticsData.componentName = 'coaching-appointment-book';
		this.analyticsData.id = 'coaching-appointment';
		this.analyticsData.pageUrl = '/health/mentor/hm';
		this.analyticsData.redirectedTo = '/scheduling/create/appointment';
	}

	ngOnInit() {}

	bookPPAppointment() {
		this.router.navigate(['/scheduling/create/appointment/v3']);
	}

	bookHCAppointment() {
		if (this.eligibleForHM) {
			this.router.navigate(['/scheduling/create/appointment/coaching']);
		} else {
			this.bookPPAppointment();
		}
	}

	viewAppointment() {
		this.router.navigate(['/scheduling/appointments']);
	}
}
